module.exports = __webpack_public_path__ + "static/media/eat.787e184c.mp3";